import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class ArrowsUpDownIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 20 20" >
            <g fill="currentColor" className="arrow-down" >
                <path d="M13.3,17.93a.38.38,0,0,1-.4-.37h0V8.21a.4.4,0,0,1,.79,0v9.34A.4.4,0,0,1,13.3,17.93Z"/>
                <path d="M13.3,17.93a.43.43,0,0,1-.29-.12L10.75,15.5a.37.37,0,0,1,0-.52h0a.4.4,0,0,1,.56,0l2,2,2-2a.4.4,0,0,1,.56,0,.36.36,0,0,1,0,.51l0,0-2.25,2.31A.45.45,0,0,1,13.3,17.93Z"/>
            </g>
            <g fill="currentColor" className="arrow-up" >
                <path d="M6.7,12.16a.38.38,0,0,1-.4-.37h0V2.45a.4.4,0,0,1,.8,0v9.34A.38.38,0,0,1,6.7,12.16Z"/>
                <path d="M9,5.13A.38.38,0,0,1,8.67,5l-2-2-2,2a.42.42,0,0,1-.56,0,.37.37,0,0,1,0-.52h0L6.41,2.2A.41.41,0,0,1,7,2.2L9.25,4.5a.36.36,0,0,1,0,.51l0,0A.39.39,0,0,1,9,5.13Z"/>
            </g>
        </SvgIcon>;
    }
}
